import { SimplePaymentFooter } from '@/components/SimplePaymentFooter';
import { SimplePaymentHeader } from '@/components/SimplePaymentHeader';
import { SupportBotton } from '@/components/SupportBotton';
import OrderSite from '@/model/OrderSite';
import React, { Fragment, JSX } from 'react';

import { Button } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import Payment from '@/model/Payment';
import OrderResponse from '@/model/OrderResponse';
import PaymentType from '@/model/PaymentType';
import { CheckoutStep, EventCheckout, FormInputNamePayment, TicketCheckout } from '../../types';
import { OrderInformationContent } from '../../companents/OrderInformationContent';
import { PersonalDataContent } from '../../companents/PersonalDataContent';
import { AddressContent } from '../../companents/AddressContent';
import { PaymentChoiceContent } from '../../companents/PaymentChoiceContent';
import { PaymentValueContent } from '../../companents/PaymentValueContent';
import { PaymentContent } from '../../companents/PaymentContent';
import { FinishedContent } from '../../companents/FinishedContent';

interface StateProps {
  step: CheckoutStep;
  order?: OrderSite;
  events: EventCheckout[];
  tickets: TicketCheckout[];
  amountItens: number;
  percent: number;
  formDataClient: FormData;
  formErrorsClient: FormErrors;
  formDataAddress: FormData;
  formErrorsAddress: FormErrors;
  payment?: Payment;
  formDataPayment: FormData;
  formErrorsPayment: FormErrors;
  validating3DS: boolean;
  formDataCreditCard: FormData;
  formErrorsCreditCard: FormErrors;
  orderResponse?: OrderResponse;
}

interface DispatchProps {
  toCurrency: (value: number) => string;
  onGoToNextStep: () => void;
  onChangeFormInputClient: OnChangeFormInput;
  onCheckCPF: (cpf: string) => void;
  onChangeFormInputAddress: OnChangeFormInput;
  onChangeCEP: (value: string) => void;
  onChangeFormInputPayment: OnChangeFormInput;
  onChangeFormInputCreditCard: OnChangeFormInput;
  onCopyText: (value: string) => void;
  onTryAgain: () => void;
  onSupportClick: () => void;
}

type Props = StateProps & DispatchProps;

export const SimplePaymentContainer: React.FC<Props> = ({
  step,
  order,
  events,
  tickets,
  amountItens,
  toCurrency,
  onGoToNextStep,
  percent,
  formDataClient,
  onChangeFormInputClient,
  onCheckCPF,
  formErrorsClient,
  formDataAddress,
  onChangeFormInputAddress,
  onChangeCEP,
  formErrorsAddress,
  payment,
  formDataPayment,
  onChangeFormInputPayment,
  formErrorsPayment,
  orderResponse,
  onCopyText,
  validating3DS,
  formDataCreditCard,
  onChangeFormInputCreditCard,
  formErrorsCreditCard,
  onTryAgain,
  onSupportClick,
}): JSX.Element => (
  <Fragment>
    <div className="wrapper w-full">
      <SimplePaymentHeader />
      <main className="overflow-hidden">
        <div className="w-full container mx-auto" style={{ paddingTop: '20px' }}>
          <div className="grid grid-cols-1 gap-1">
            <div className="col-span-1 col-start-1">
              <section
                className="mb-[20px] ml-[10px] md:shadow-xs sm:p-[15px] p-[0]"
                id="selectPrincipal"
                // style={{ borderRight: '1px solid rgba(128, 128, 128, 0.1)' }}
              >
                {step === CheckoutStep.INFORMATION && (
                  <OrderInformationContent
                    order={order}
                    events={events}
                    tickets={tickets}
                    amountItens={amountItens}
                    toCurrency={toCurrency}
                  />
                )}

                {step === CheckoutStep.CLIENT_DATA && (
                  <PersonalDataContent
                    formData={formDataClient}
                    onChangeFormInput={onChangeFormInputClient}
                    onCheckCPF={onCheckCPF}
                    formErrors={formErrorsClient}
                  />
                )}

                {step === CheckoutStep.ADDRESS && (
                  <AddressContent
                    formData={formDataAddress}
                    onChangeFormInput={onChangeFormInputAddress}
                    onChangeCEP={onChangeCEP}
                    formErrors={formErrorsAddress}
                  />
                )}

                {step === CheckoutStep.PAYMENT_VALUE && (
                  <PaymentValueContent
                    formData={formDataPayment}
                    formErrors={formErrorsPayment}
                    onChangeFormInput={onChangeFormInputPayment}
                  />
                )}

                {step === CheckoutStep.PAYMENT_CHOICE && (
                  <PaymentChoiceContent
                    payment={payment}
                    toCurrency={toCurrency}
                    formData={formDataPayment}
                    onChangeFormInput={onChangeFormInputPayment}
                    formErrors={formErrorsPayment}
                  />
                )}

                {step === CheckoutStep.PAYMENT && (
                  <PaymentContent
                    orderResponse={orderResponse}
                    paymentType={Number(formDataPayment[FormInputNamePayment.paymentType])}
                    onCopyText={onCopyText}
                    validating3DS={validating3DS}
                    formData={formDataCreditCard}
                    onChangeFormInput={onChangeFormInputCreditCard}
                    formErrors={formErrorsCreditCard}
                  />
                )}

                {orderResponse && step === CheckoutStep.FINISHED && (
                  <FinishedContent orderResponse={orderResponse} onTryAgain={onTryAgain} />
                )}

                <div>
                  {((step === CheckoutStep.PAYMENT &&
                    Number(formDataPayment[FormInputNamePayment.paymentType]) ===
                      PaymentType.CREDIT_CARD &&
                    !validating3DS) ||
                    (step !== CheckoutStep.FINISHED && step !== CheckoutStep.PAYMENT)) && (
                    <div className="mt-[40px] flex items-center justify-center">
                      <Button
                        type="submit"
                        title={`Avançar${formDataPayment[FormInputNamePayment.paymentValueWithFee] ? ` (${toCurrency(Number(formDataPayment[FormInputNamePayment.paymentValueWithFee]))})` : ''}`}
                        buttonStyle="primary"
                        size="xlg"
                        className="w-full mb-[25px] md:w-[500px]"
                        onClick={() => onGoToNextStep()}
                      />
                    </div>
                  )}

                  <div
                    className="flex w-full h-4 bg-gray-200 rounded-full overflow-hidden"
                    role="progressbar"
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="flex flex-col justify-center rounded-full overflow-hidden bg-red-400 text-xs text-white text-center whitespace-nowrap transition duration-500"
                      style={{ width: `${percent}%` }}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <SimplePaymentFooter />
    </div>
    <SupportBotton onCLick={onSupportClick} />
  </Fragment>
);
